/**
 * Internal dependencies
 */
import * as actions from 'state/action-types';

export default (id, report) => ({
	type: actions.EDIT_REPORT,
	payload: {
		id,
		report,
	},
});
